import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const Accreditations = ({ accredations }) => {
    const { t } = useTranslation()

    return (
        <Block isRender={accredations?.length > 0}>
            <SectionCard icon="mdi:certificate" titleKey="accredations">
                <div className="accreditations-grid">
                    {accredations?.map((acc, index) => (
                        <div key={index} className="accreditation-item">
                            <div className="accreditation-icon">
                                <Icon icon="mdi:certificate" />
                            </div>
                            <div className="accreditation-name">{acc}</div>
                            <div className="accreditation-status">{t("certified")}</div>
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default Accreditations

